import styled from '@emotion/styled';

export const StyledListItemText = styled.span`
  font-family: 'Futura New Bold', serif;
  margin: 0.5rem;
  color: #c3b9b5;
  font-size: 1.25rem;
  line-height: 1.25rem;
`;

export const StyledListSubItemText = styled.span`
  font-family: 'Futura New Bold', serif;
  margin: 0.1rem;
  color: #c3b9b5;
  font-size: 1.1rem;
  line-height: 1.25rem;
`;
